import type { IconData } from '@stacksjs/iconify-core'

export const compressPdf: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M15 34h18M15 24h18M15 14h9M2.5 29c1.123-.876 2.851-2.437 3.966-3.646c.74-.803.74-1.905 0-2.708C5.35 21.437 3.622 19.876 2.5 19m43 10c-1.123-.876-2.851-2.437-3.965-3.646c-.74-.803-.74-1.905 0-2.708c1.114-1.209 2.842-2.77 3.965-3.646m-2.706 14.5c-.139 2.918-.33 5.116-.511 6.714c-.25 2.202-1.903 3.848-4.104 4.105c-2.815.329-7.413.681-14.18.681s-11.364-.352-14.18-.68c-2.2-.258-3.852-1.904-4.103-4.106c-.181-1.598-.372-3.796-.51-6.714m37.077-18.657c-.734-1.39-2.18-3.555-4.979-6.284c-4.16-4.057-7.04-5.2-7.936-5.479A172 172 0 0 0 24 3c-6.767 0-11.365.353-14.18.681c-2.2.257-3.853 1.903-4.104 4.105c-.181 1.598-.372 3.796-.51 6.714\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default compressPdf
